import { render, staticRenderFns } from "./dialogEditItemMobile.vue?vue&type=template&id=358ad213&scoped=true"
import script from "./dialogEditItemMobile.vue?vue&type=script&lang=js"
export * from "./dialogEditItemMobile.vue?vue&type=script&lang=js"
import style0 from "./dialogEditItemMobile.vue?vue&type=style&index=0&id=358ad213&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ad213",
  null
  
)

export default component.exports